import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-fixed-rates',
  templateUrl: './info-fixed-rates.component.html',
  styleUrls: ['./info-fixed-rates.component.scss']
})
export class InfoFixedRatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
